<template>
  <div class="image-input">
    <div
      :class="{'over': isDragOver}"
      class="image-input__field"
      @dragleave="onDrag('leave')"
      @dragover.prevent="onDrag('over')"
      @drop.stop="onDrop"
    >
      <input
        accept="image/*"
        multiple
        title
        type="file"
        @change="inputFileList($event.target.files)"
      >
      <img
        src="../assets/camera.png"
        width="80"
      >
    </div>
  </div>
</template>

<script>
// FILE SIZE MAX
const MAX_FILE_SIZE = 5242880;
export default {
  data() {
    return {
      isDragOver: false,
    };
  },
  methods: {
    onDrag(type) {
      this.isDragOver = type === "over";
    },
    onDrop(event) {
      this.isDragOver = false;
      // const files = event.dataTransfer.files;
      // console.log("onDrop called")
      // this.inputFileList(files);
    },
    async inputFileList(fileList) {
      // event.target.filesはファイルデータが格納されたリストです
      if (fileList === 0) {
        return
      }
      // FileAPIは、APIなので複数ファイルを扱う時は、
      // for文の中でawaitする必要があります
      const successFile = [];
      const errorFile = [];

      for (let index = 0; index < fileList.length; index++) {
        let file = fileList[index]
        // ファイルデータ用のオブジェクトを用意します
        const fileData = {
          file: file,
          name: file.name,
          type: '',
          size: {width: 0, height: 0},
          url: '',
          isMaxSize: file.size > MAX_FILE_SIZE // 5MB以上判定
        };
        const image = new Image();
        const fileReader = new FileReader();
        // 即時関数をawaitすることで処理の完了までループが終わりません
        await (async () => {
          fileReader.onload = async () => {
            image.src = fileReader.result;

            // ファイルURL取得
            fileData.url = fileReader.result;
            fileData.thumb = fileReader.result;
            fileData.src = fileReader.result;
            // 即時関数をawaitすることでfileData.sizeのデータを担保します
            await (() => {
              image.onload = () => {
                // ファイルサイズ取得
                fileData.size = {width: image.naturalWidth, height: image.naturalHeight}
              }
            })()
          };
          // FileAPIの起動
          fileReader.readAsDataURL(file)
        })();

        if (fileData.isMaxSize) {
          errorFile.push(fileData);
        } else {
          successFile.push(fileData);
        }
      }

      this.$emit('success', successFile);
      this.$emit('error', errorFile);

    }
  }
}
</script>
<style>
.image-input {
  height: 130px;
  width: 130px;
}

.image-input__field {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-input__field.over {
  background-color: #666;
}

.image-input__field > input {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}

.image-input__field > p {
  color: #aaa;
  text-align: center;
}
</style>
